import { render } from "./ResourceTable.vue?vue&type=template&id=22225599&scoped=true"
import script from "./ResourceTable.vue?vue&type=script&lang=js"
export * from "./ResourceTable.vue?vue&type=script&lang=js"

import "./ResourceTable.vue?vue&type=style&index=0&id=22225599&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22225599"]])

export default __exports__